<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 48 48" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path data-follow-fill="currentColor" d="m44 17.6-3 3c-1.7 1.9-2.4 4.6-1.8 7.1.7 2.5 2.4 9.5 2.8 10.7.3 1.3 0 2.7-1 3.7-1.5 1.4-3.8 1.5-5.3.1l-5.6-5.5c-1.5-1.5-4-1.5-5.5 0l-2.7 2.7c-1.5 1.5-3.6 2.3-5.7 2.4-1.8 0-3.5-.6-4.7-1.9-1.3-1.2-8.7-8.6-8.8-8.6-.4-.4-.6-1-.6-1.5 0-.6.2-1.1.6-1.5.4-.4 1-.6 1.5-.6h.3c.1 0 3.2.6 5.1.8.3 0 .6.1.9.1.3 0 .5-.1.7-.2C11.5 28 33 6.8 33 6.8c3.1-2.8 7.8-2.7 10.7.2 3 2.9 3.1 7.5.3 10.6zm-22.2-4.7c-.1 0-.1.1 0 0l-6.9 7c-.2.3-.5.4-.9.4s-.7-.2-.9-.4L8 15c-1.4-1.5-1.3-3.8.1-5.3.8-.7 1.8-1.1 2.9-1.1.3 0 .7 0 1 .1 1 .2 6.7 1.7 9.2 2.3.5.1.9.6.9 1.1-.1.3-.2.6-.3.8zm0 0" :fill="_fill" /></g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
